import { uniqueId } from "lodash";
import React, { ChangeEvent } from "react";

interface ICheckbox {
  label?:    React.ReactNode;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  id?:       string;
  checked?:  boolean;
  disabled?: boolean;
}

export function Checkbox({
  label,
  onChange,
  className,
  id = uniqueId(),
  checked,
  disabled,
}: ICheckbox) {
  return (
    <div className={"flex items-center " + (className ?? "")}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => {
          if (onChange) onChange(e);
        }}
      />
      <label htmlFor={id} className="text-sm text-dark-blue ml-2">
        {label}
      </label>
    </div>
  );
}